var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftSelectTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28784 11.4212L7.28784 0.57883C7.28784 0.0657529 6.66828 -0.195626 6.30041 0.172241L0.879222 5.59343C0.656566 5.81609 0.656566 6.18395 0.879222 6.40671L6.30041 11.8279C6.66828 12.1957 7.28784 11.9343 7.28784 11.4212Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftSelectTree);
export default __webpack_public_path__ + "static/media/arrow-left-select-tree.94fd2f3fb29023a2e9668abf32269547.svg";
export { ForwardRef as ReactComponent };